import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import PendingApprovalsTable from "./components/PendingApprovalsTable"
import UpcomingLeavesTable from "./components/UpcomingLeavesTable"
import UpcomingBirthdaysTable from "./components/UpcomingBirthdaysTable"
import PublicHolidaysTable from "./components/PublicHolidaysTable"
import { 
  Cake, Calendar, 
  CalendarDays, Clock,
  CircleAlert, TrendingUp,

} from "lucide-react";
import ThemedSummaryCard from "components/widget/ThemedSummaryCard";
import {
  getTeamOverviewStat
} from "../../../redux/overview/overviewState";



const TeamOverviews = ({
  getStats,
  recordStat
}) => {

  useEffect(() => {
    getStats();
  }, [getStats]);

	return (

    <div className="space-y-6">
	    <div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <ThemedSummaryCard
            title={"Upcoming Leaves"}
            count={recordStat?.approved_leaves}
            description="Next 30 days"
            badgeText={`+${recordStat?.leave_this_week} this week`}
            badgeIcon={<TrendingUp />}
            icon={<Calendar />}
            theme="blue"
          />	

          <ThemedSummaryCard
            title={"Pending Approvals"}
            icon={<CircleAlert />}
            count={recordStat?.pending_approvals}
            badgeText={"Urgent"}
            badgeIcon={<Clock />}
            description={"Requires action"}
            theme="orange"
          />

          <ThemedSummaryCard
            title={"Upcoming Birthdays"}
            icon={<Cake />}
            count={recordStat?.upcoming_birthdays}
            badgeText={`${recordStat?.birthday_this_week} this week`}
            description={"This month"}
            theme="purple"
          />		
          <ThemedSummaryCard
            title={"Public Holidays"}
            icon={<CalendarDays />}
            count={recordStat?.holidays}
            badgeText={`${recordStat?.total_countries} locations`}
            description={"Next 3 months"}
            theme="emerald"
          />	
          
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <UpcomingLeavesTable/>
          <PendingApprovalsTable/>
          <UpcomingBirthdaysTable/>
          <PublicHolidaysTable/>
      </div>
    </div>
	

      
    );
};

const mapStateToProps = (state) => ({
  recordStat: state.overview.teamOverviewStat?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getStats: (data) => dispatch(getTeamOverviewStat(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamOverviews);